import React from "react";
import { Table } from "react-bootstrap";
import type { BillingItem, BillingEventType } from "../../../../api/ads";

import "./BillingTable.css";

export interface BillingTableProps {
  billing: BillingItem[];
}

const eventTypeMeta: Record<BillingEventType, { label: string; className: string }> = {
  CLICK:      { label: "CLICK",      className: "billing-event-badge billing-event-badge--click" },
  IMPRESSION: { label: "IMPRESSION", className: "billing-event-badge billing-event-badge--impression" },
  CPM:        { label: "CPM",        className: "billing-event-badge billing-event-badge--cpm" },
  FLAT:       { label: "FLAT",       className: "billing-event-badge billing-event-badge--flat" },
};

const formatMoney = (value: number) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(value);

const formatTimestamp = (iso: string) => {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const date = d.toISOString().slice(0, 10);
  const time = d.toISOString().slice(11, 16);
  return `${date} ${time}`;
};

export const BillingTable: React.FC<BillingTableProps> = ({ billing }) => {
  return (
    <div className="billing-table-wrapper">
      <Table responsive className="billing-table">
        <thead>
          <tr>
            <th>Advertiser Name</th>
            <th>Campaign Name</th>
            <th>Event Type</th>
            <th>Reference ID</th>
            <th>Amount</th>
            <th>Timestamp</th>
          </tr>
        </thead>
        <tbody>
          {billing.map((b) => {
            const meta = eventTypeMeta[b.eventType];
            return (
              <tr key={b.id}>
                <td>{b.advertiserName}</td>
                <td>{b.campaignName}</td>
                <td>
                  <span className={meta.className}>{meta.label}</span>
                </td>
                <td>{b.referenceId}</td>
                <td>{formatMoney(b.amount)}</td>
                <td>{formatTimestamp(b.timestamp)}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};
